import { useSelector as reduxUseSelector } from 'react-redux';

/** @type {import('react-redux').TypedUseSelectorHook<RootState>} */
export const useSelector = reduxUseSelector;
